// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Private Endpoint Service API
 * private-endpoint-service-api manages Private Endpoint Services in ingress clusters
 *
 * The version of the OpenAPI document: 1.0
 * Contact: team-aura-networking@neotechnology.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OrchestraConnection } from './OrchestraConnection';
import {
  OrchestraConnectionFromJSON,
  OrchestraConnectionFromJSONTyped,
  OrchestraConnectionToJSON,
  OrchestraConnectionToJSONTyped,
} from './OrchestraConnection';
import type { NetworkServiceDetails } from './NetworkServiceDetails';
import {
  NetworkServiceDetailsFromJSON,
  NetworkServiceDetailsFromJSONTyped,
  NetworkServiceDetailsToJSON,
  NetworkServiceDetailsToJSONTyped,
} from './NetworkServiceDetails';

/**
 *
 * @export
 * @interface RegionalIngressState
 */
export interface RegionalIngressState {
  /**
   *
   * @type {NetworkServiceDetails}
   * @memberof RegionalIngressState
   */
  exposedService?: NetworkServiceDetails;
  /**
   * Per-orchestra connection health from the PrivateEndpoint CRs, keyed by cluster name.
   * @type {{ [key: string]: OrchestraConnection; }}
   * @memberof RegionalIngressState
   */
  orchestras?: { [key: string]: OrchestraConnection };
}

/**
 * Check if a given object implements the RegionalIngressState interface.
 */
export function instanceOfRegionalIngressState(
  value: object,
): value is RegionalIngressState {
  return true;
}

export function RegionalIngressStateFromJSON(json: any): RegionalIngressState {
  return RegionalIngressStateFromJSONTyped(json, false);
}

export function RegionalIngressStateFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): RegionalIngressState {
  if (json == null) {
    return json;
  }
  return {
    exposedService:
      json['exposed_service'] == null
        ? undefined
        : NetworkServiceDetailsFromJSON(json['exposed_service']),
    orchestras:
      json['orchestras'] == null
        ? undefined
        : mapValues(json['orchestras'], OrchestraConnectionFromJSON),
  };
}

export function RegionalIngressStateToJSON(json: any): RegionalIngressState {
  return RegionalIngressStateToJSONTyped(json, false);
}

export function RegionalIngressStateToJSONTyped(
  value?: RegionalIngressState | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    exposed_service: NetworkServiceDetailsToJSON(value['exposedService']),
    orchestras:
      value['orchestras'] == null
        ? undefined
        : mapValues(value['orchestras'], OrchestraConnectionToJSON),
  };
}
